import React from 'react';
import Paper from '@material-ui/core/Paper';
import urlBase from '../../../url-base';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'material-ui/Dialog';
import Grid from '@material-ui/core/Grid';
import TextField from 'material-ui/TextField';
import axios from 'axios';
import { Button} from 'reactstrap';
import { Colors, Styles, tableStyles } from '../../../../src/styles/theme';
/* import ReactPaginate from 'react-paginate'; */


class PendencieList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: 'loading',
      count: 0,
      pageCount: 0,
      perPage: 10, // Quantidade de Pendências por página
      skip: 0,

      name: '',

      modalOpen: false,
      loadingSave: false,
      success: null,
      emailError: {
        display: 'none',
        msg: ''
      },
      showTable: false

    };

    this.styles = {
      error: {
        textAlign: 'center',
        fontSize: 18,
        color:'#ea0000',
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: 'center',
        fontSize: 18,
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      titleTable: {
        textAlign: 'center',
        padding: 0
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5
      },
      inputs: {
        marginLeft: 10,
      },
      sendFormSuccess: {
        padding: 10,
        color: '#155724',
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb'
      },
      sendFormError: {
        padding: 10,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      }
    };

    // Campos obrigatórios
    this.errorField = {
      name: ''
    };
  }


  componentDidMount() {
    this.getData(urlBase.loopBack + 'Pendencies');
  }

  getData(url) {
    axios.get(url)
    .then((response) => {
      let state = this.state;

      if (response.data.length == 0)
        state.data = 'zero';
      else
        state.data = response.data;
      if (state.showTable == false) {
        state.showTable = true;

        $(document).ready( function () {
          $('#table_id').DataTable({
            "language": {
              "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
            },
            "order": [[0, "asc"]],
            lengthMenu: [
              [10, 25, 50, 100, -1],
              ['10', '25', '50', 100, 'Todas']
            ]
          });
        });
      }
      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));
  }

  // Monitora mudanças a atualiza estados dos inputs text
  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.value == '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  openFormModal() {
    let state = this.state;
    state.modalOpen = true;
    this.setState(state);
  }

  saveForm() {
    if (this.state.name.length > 0) {
      let state = this.state;
      state.loadingSave = true;
      this.setState(state);

      let dataPost = {
        name: this.state.name
      };
      let url = urlBase.loopBack + 'Pendencies/saveWithCode';
      
      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.loadingSave = false;
        state.success = true;
        this.errorField.name = '';
        this.setState(state);
        this.stateDefault();
      })
      .catch(function () {
        let state = this.state;
        state.success = false;
        this.setState(state);
      }.bind(this));
    }
    else {
      let state = this.state;
      this.errorField.name = 'Campo obrigatório';
      this.setState(state);
    }
  }

  stateDefault() {
    let state = this.state;
    state.name = '';
    this.setState(state);
  }
  
  handleModalClose() {
    this.setState({modalOpen: false});
    this.getData(urlBase.loopBack + 'Pendencies');
  }

  edit() {
    alert('Em desenvolvimento');
  }


  render() {
   

    return (
      <div>
          <style>{tableStyles}</style>    

          {/* CABEÇALHO DA PÁGINA COM BOTÃO ADICIONAR */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginBottom: '20px',
            paddingLeft: '10px' 
          }}>
            <h2 style={{ 
              margin: 0, 
              fontSize: '1.4rem', 
              color: Colors.textDark, 
              fontWeight: 500,
              textTransform: 'uppercase' 
            }}>
              Gerenciar Pendências
            </h2>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
              onClick={this.openFormModal.bind(this)}
            >
              Nova Pendência
          </Button>        

          </div>              
        {
          this.state.data == 'loading' ? (
        <div style={{textAlign: 'center'}}>
          <CircularProgress />
          <p>Carregando...</p>
        </div>
          ) : (
            this.state.data == 'error' ? (
            <p style={this.styles.error}>
              Erro ao buscar dados.
            </p>
                ) : (
                  this.state.data == 'zero' ? (
            <div style={this.styles.zero}>
              <p>Nenhuma pendência encontrada.</p>
            </div>
                  ) : (
            <div>
            <Paper style={{overflow: 'auto'}}>

                    <table
                      id="table_id"
                      className="table-striped dataTable"
                      style={{ width: '100%' }} >
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Pendência</th>
                        <th>Ação</th>
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.data.map((item) =>
                      <tr
                        
                      >
                        <td >{item.code}</td>
                        <td >{item.name}</td>
                        
                        <td onClick={this.edit.bind(this, item.id)}
                            style={{cursor:'pointer', padding:0}}>
                          <i className="fas fa-edit">&nbsp;</i>
                        </td>                  
                      </tr>
                      )}
                    </tbody>

        
                </table>     

            </Paper>
        </div>
              )
            )
          )
        }
        <Dialog
         title={
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 24px',
              backgroundColor: Colors.backgroundLight,
              borderBottom: `1px solid ${Colors.borderLight}`,
              borderRadius: '8px 8px 0 0'
            }}>
              <span style={{ fontSize: '1.2rem', fontWeight: 600, color: Colors.textDark, textTransform: 'uppercase' }}>
                {this.state.tituloDialog} Pendências
              </span>
              <img
                style={{ cursor: 'pointer', width: '16px', opacity: 0.5 }}
                src={urlBase.client + '/assets/images/icons/icon_close.png'}
                onClick={this.handleModalClose.bind(this)}
              />
            </div>
          }
          titleStyle={{ padding: 0 }}
          bodyStyle={{ padding: '24px' }}
          modal={false}
          open={this.state.modalOpen}
          onRequestClose={this.handleModalClose.bind(this)}
          autoScrollBodyContent={true}
          contentStyle={{ width: '90%', maxWidth: '700px', borderRadius: '8px', overflow: 'hidden' }}
        >        
 
          <div>
            {/* Mensagem de retorno do formulário */
              this.state.success != null ? (
                this.state.success == true ? (/* Formulário salvo com sucesso */
              <Grid container spacing={24} style={{marginTop:30}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <div style={{textAlign: 'center'}}>
                    <p style={this.styles.sendFormSuccess}>Pendência salva com sucesso</p>
                  </div>
                </Grid>
              </Grid>
                ) : (/* Erro ao enviar formulário */
              <Grid container spacing={24} style={{marginTop:30}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <div style={{textAlign: 'center'}}>
                    <p style={this.styles.sendFormError}>Erro ao salvar pendência</p>
                  </div>
                </Grid>
              </Grid>
                )
              ) : ('')
            }

            {/* Loading de salvar o formulário*/
              this.state.loadingSave == true ? (
            <div id="loading_form">
              <Grid container spacing={24} style={{marginTop:30}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <div style={{textAlign: 'center'}}>
                    <CircularProgress />
                    <p>Enviando...</p>
                  </div>
                </Grid>
              </Grid>
            </div>
              ) : (/* Formulário*/
            <div id="form">
              <Grid container spacing={24}>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <TextField
                    autoFocus
                    errorText={this.errorField.name}
                    style={this.styles.inputs}
                    hintText="Pendencia"
                    floatingLabelText="Pendencia *"
                    type="text"
                    name="name"
                    value={this.state.name}
                    fullWidth={true}
                    onChange={(e) => this.onChange(e)}
                  />
                </Grid>
              </Grid>
               {/* --- RODAPÉ DE AÇÕES --- */}
                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <button
                    type="button"
                    onClick={this.handleModalClose.bind(this)}
                    style={{ 
                      ...Styles.buttonCancel, 
                      backgroundColor: Colors.textLight, // Usando cinza para cancelar
                      textTransform: 'none' 
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    onClick={this.saveForm.bind(this)}
                    style={{ 
                      ...Styles.buttonSuccess, 
                      fontWeight: 'bold', 
                      textTransform: 'none' 
                    }}
                  >
                    Salvar 
                  </button>
                </div>

            </div>
              )
            /*#form*/}

          </div>
        </Dialog>
      </div>
    );

  }

}

export default PendencieList;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Pendencies/PendencieList.js
 **/